export enum TaskStatusEnum {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  REJECTED = 'REJECTED',
  COMPLETE = 'COMPLETE',
  OVERDUE = 'OVERDUE',
  AMENDMENT_REQUIRED = 'AMENDMENT_REQUIRED',
  AMENDMENT_REQUESTED = 'AMENDMENT_REQUESTED',
}

export const isSupplierTaskOpenForSubmission = (task: {
  completedOn?: string | null
  submissionsClosedAt?: string | null
}): boolean => !task.completedOn && !task.submissionsClosedAt
